import { DecimalPipe } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import { AmendmentReasons } from '@app/features/amendments/amendment.model';

/**
 * Le récapitulatif d'un avenant : ce qu'il change, les motifs que le produit en déduit, le nom de
 * son futur fichier, et ce qui l'empêcherait de s'enregistrer (RG-avenant-motifs).
 */
@Component({
  selector: 'app-amendment-summary',
  imports: [DecimalPipe],
  templateUrl: './amendment-summary.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./amendment-summary.scss'],
})
export class AmendmentSummary {
  readonly employee = input<string>('');
  readonly contractLabel = input<string>('');
  readonly effectiveDate = input<string | null>(null);
  readonly effectiveDateLabel = computed(() => {
    const date = this.effectiveDate();
    return date ? moment(date).format('DD/MM/YYYY') : '—';
  });
  readonly durationLabel = input<string>('');
  readonly reasons = input<AmendmentReasons | null>(null);
  readonly assignmentLabel = input<string>('');
  readonly fileName = input<string | null>(null);
}
